module.exports = __webpack_public_path__ + "img/dash-card-icon-3.4ab038bc.svg";